/* eslint-disable react/destructuring-assignment */
import React from 'react';

import { Flex } from '@chakra-ui/react';
import { format } from 'date-fns';

import { Avatar } from 'uiToolkitV1/Avatar';
import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

import { PraiseAdvice } from './common';

const MobileResponsiveColumn = (props) => {
  const { employee, date, feedbackType } = props.value ?? {};
  const { value: dateValue } = date ?? {};
  const { value: feedbackTypeValue } = feedbackType ?? {};
  const { imageUrl, value } = employee;
  const { displayName } = value ?? {};

  return (
    <Flex w="100%" h="100%" alignItems="center">
      <Avatar name={displayName} src={imageUrl} />
      <Flex flexDirection="column" sx={{ marginLeft: '8px' }}>
        <TextBodyMedium>{displayName}</TextBodyMedium>
        <TextLabel>{format(new Date(dateValue), 'PP')}</TextLabel>
        <PraiseAdvice value={feedbackTypeValue} />
      </Flex>
    </Flex>
  );
};

export default MobileResponsiveColumn;
